import {ajax_get, ajax_post} from "./index";

// 获取标单项
export const getFormApi = (data) => ajax_get('/museumfillinfo', data);
// 审批
export const shepi = (data) => ajax_post('/museumregapprove', data);

